import { Injectable, OnInit } from '@angular/core';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule, AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';
import { AngularFireAuthModule, AngularFireAuth, FirebaseAuthStateObservable } from 'angularfire2/auth';
import { FirebaseApp } from 'angularfire2';
import { Observable } from 'rxjs/Observable';
import { Router, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class AuthService implements CanActivateChild {

  public user: Observable<firebase.User>;
  public uid: string = '';
  public email: string = '';
  public name: string = '';
  public isAdmin: boolean = false;
  public UserStatus: boolean = false;
  public redirectUrl: string = '';
  public emitChangeSource: Subject<any>;
  public changeEmitted$: Observable<any>;

  constructor(public db: AngularFireDatabase, public afAuth: AngularFireAuth, public router: Router, public firebaseApp: FirebaseApp /*, public FirebaseAdminAuth: FirebaseAdmin.auth.Auth*/) {
    this.emitChangeSource = new Subject<any>();
    this.changeEmitted$ = this.emitChangeSource.asObservable();

    this.afAuth.auth.onAuthStateChanged(r => {
      if (r) {
        this.uid = r.uid;
        this.email = r.email;
        this.db.object('/admin/' + this.uid + '/').$ref.once('value').then(s => {
          this.isAdmin = true;
        }).catch(e => {
          this.isAdmin = false;
        });

        this.db.object('/member/' + this.uid + '/').$ref.once('value').then(s => {
          let mamber = s.val();
          this.name = mamber['name'];
          this.UserStatus = mamber.status === 1;
          this.emitChange(this.UserStatus);
        }).catch(e => {
          this.UserStatus = false;
        });
      } else {
        this.uid = '';
        this.email = '';
        this.isAdmin = false;
        this.UserStatus = false;
      }
    });

  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let url: string = state.url;
    return this.afAuth.authState.map(success => {
      switch (true) {
        case url.indexOf('maintain') !== -1://後台網址
          if (success) {
            return true;
          } else {
            this.redirectUrl = url;
            this.router.navigate(['/maintain/login']);
            return false;
          }

        default:
          return true;
      }
    }).first();
  }

  /**
   * 管理者登入
   * @param email
   * @param password
   */
  login_admin(email: string, password: string): Promise<boolean> {
    return Promise.resolve(
      this.afAuth.auth.signInWithEmailAndPassword(email, password).then((success) => {
        this.db.object('/admin_log/' + success.uid + '/' + (new Date()).getTime()).set({ 'action': 'login' });
        return true;
      }).catch((error) => {
        this.db.list('/admin_log/admin_login_error').push({ 'date': (new Date()).getTime(), 'email': email });
        console.log('fail = ' + error);
        return false;
      })
    );
  }

  /**
   * 管理者登出
   */
  logout_admin(): Promise<void> {
    this.db.object('/admin_log/' + this.uid + '/' + (new Date()).getTime()).set({ 'action': 'logout' });
    return Promise.resolve(this.afAuth.auth.signOut());
  }

  /**
   * 會員登入
   * @param email
   * @param password
   */
  login_user(email: string, password: string): Promise<boolean> {
    return Promise.resolve(
      this.afAuth.auth.signInWithEmailAndPassword(email, password).then((success) => {
        this.db.list('/log/user_login').push({ uid: success.uid, rate: (new Date()).getTime() });
        return true;
      }).catch((error) => {
        this.db.list('/log/user_login_error').push({ date: (new Date()).getTime(), email: email });
        console.log('fail = ' + error);
        return false;
      })
    );
  }

  /**
   * 會員者登出
   */
  logout_user(): Promise<void> {
    this.db.list('/log/user_logout').push({ date: (new Date()).getTime(), uid: this.uid });
    alert('確認登出!');
    return Promise.resolve(this.afAuth.auth.signOut());
  }

  /**
   * 寄送重置密碼的email
   * @param email
   */
  sendPasswordResetEmail(email: string) {
    return Promise.resolve(this.afAuth.auth.sendPasswordResetEmail(email));
  }

  /**
   * email帳號建立
   * @param email
   * @param password
   */
  emailSignUp(email: string, password: string) {
    return Promise.resolve(this.afAuth.auth.createUserWithEmailAndPassword(email, password));
  }

  /**
   * email帳號登入
   * @param email
   * @param password
   */
  emailLogin(email: string, password: string) {
    return Promise.resolve(this.afAuth.auth.signInWithEmailAndPassword(email, password));
  }

  /**
   * gmail登入
   */
  googleLogin() {
    return Promise.resolve(this.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider()));
  }

  /**
   * fb登入
   */
  facebookLogin() {
    return Promise.resolve(this.afAuth.auth.signInWithPopup(new firebase.auth.FacebookAuthProvider()));
  }


  emitChange(change: any) {
    this.emitChangeSource.next(change);
  }


}



// WEBPACK FOOTER //
// ./src/app/public/auth.service.ts